import { Dispatch } from "redux";
import {QuickbetsXFilterAction, QuickbetsXFilterActionTypes} from "../../types/QuickbetX/quickbetXsFilterTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getQuickbetXFilterData = (code: string, data: any): any => {
    return async (dispatch: Dispatch<QuickbetsXFilterAction>) => {
        try {
            dispatch({ type: QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_FILTER_DATA });
            const response = await axios({
                method: 'POST',
                url: `/api/quickbetx_cards/${code}`,
                data: data,
                withCredentials: false
            });

            dispatch({ type: QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_DATA_FILTER_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_DATA_FILTER_ERROR, payload: errorPayload });
        }
    }
}
